import React, { useState, useEffect, useRef } from 'react';
import { useAppDispatch, useAppSelector } from '../../../redux/hooks';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

// Components 
import Box from '@mui/material/Box';
import Plan from './plans/Plan';
// --- REMOVED: No longer need the custom checkout component ---
// import Checkout from './checkout/Checkout';
import { setDashboardSection, setIsLoadingPopupOpened, setIsUpdateSeatsPopupOpened } from '../../../redux/features/general/navigation';
import Section from '../../general/containers/Section';
import { createCheckoutSession } from '../../../routes/doctor/billing';
import { setNotificationMessage } from '../../../redux/features/general/notification';

interface Props { 

}; 

const Paywall: React.FC<Props> = ({ }) => {
    const dispatch = useAppDispatch(); 
    const { t } = useTranslation(); 
    const navigate = useNavigate(); 

    const colors = useAppSelector(state => state.theme.colors); 
    const subscription = useAppSelector(state => state.billing.subscription); 
    // --- REMOVED: isSelectedPlan is no longer needed for this flow ---
    // const isSelectedPlan = useAppSelector(state => state.paywall.isSelectedPlan); 

    const handleSubscription = async () => { 
        // This logic for existing subscribers remains the same
        if (subscription && ((subscription.status === 'trialing') || (subscription.status === 'active'))) { 
            dispatch(setDashboardSection('billing')); 
            dispatch(setIsUpdateSeatsPopupOpened(true)); 
        } else { 
            // --- KEY CHANGE: New logic for new subscribers ---
            dispatch(setIsLoadingPopupOpened(true)); 
            try {
                const res = await createCheckoutSession();
                // If the backend provides the session URL, redirect the user
                if (res?.data?.session?.url) {
                    window.location.href = res.data.session.url;
                } else {
                    // Handle cases where the session URL isn't returned
                    dispatch(setIsLoadingPopupOpened(false));
                    dispatch(setNotificationMessage(res?.data?.error || t('checkoutError', 'Could not initiate subscription. Please try again.')));
                    console.error("Failed to create Stripe checkout session:", res?.data?.error);
                }
            } catch (error) {
                // Handle network or other errors
                dispatch(setIsLoadingPopupOpened(false));
                dispatch(setNotificationMessage(t('checkoutError', 'An error occurred. Please try again.')));
                console.error("Error during checkout session creation:", error);
            }
        }; 
    }; 

    const navBarHeight = '5vh';
    const sideBarWidth = '70px';

    return (
        <Section
            extraStyle={{
                position: 'absolute',
                top: navBarHeight,
                left: sideBarWidth,
                width: `calc(100% - ${sideBarWidth})`,
                height: `calc(100% - ${navBarHeight})`,
                boxSizing: 'border-box',
                overflow: 'auto',
                backgroundColor: colors?.container,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center', 
                justifyContent: 'center',
                padding: '1rem', 
            }}
        >
            <Plan 
                handler={handleSubscription}
            />
            {/* --- REMOVED: The custom checkout component is no longer rendered here --- */}
            {/* {isSelectedPlan && <Checkout />} */}
        </Section>
    );
};

export default Paywall;